import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { PageHeader, Card } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { User, KeyRound } from "lucide-react";
import { STATES } from "@/lib/states";

export default function Profile() {
  const { user, setUser } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({ name: user?.name || "", designation: user?.designation || "", state: user?.state || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  const saveProfile = async () => {
    try {
      const { data } = await api.put("/users/profile", form);
      setUser(data);
      toast.success(t("save"));
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const changePw = async () => {
    try {
      await api.post("/auth/change-password", pw);
      setPw({ current_password: "", new_password: "" });
      toast.success(t("changePassword"));
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader title={t("profile")} />
      <Card className="mb-6">
        <div className="flex items-center gap-2 font-head font-semibold text-slate-900 mb-4"><User className="h-4 w-4" /> {t("editProfile")}</div>
        <div className="space-y-4">
          <div>
            <Label>{t("badgeNumber")}</Label>
            <Input value={user?.badge_number} disabled className="mt-1.5 font-mono" />
          </div>
          <div>
            <Label>{t("name")}</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="profile-name" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>{t("designation")}</Label>
              <Input value={form.designation} disabled className="bg-slate-50 cursor-not-allowed" data-testid="profile-designation" />
            </div>
                <div className="space-y-2">
                  <Label>{t("state")}</Label>
                  <Input value={form.state} disabled className="bg-slate-50 cursor-not-allowed" />
                </div>
          </div>
          <Button onClick={saveProfile} className="bg-[#0F172A] hover:bg-slate-800" data-testid="profile-save">{t("save")}</Button>
        </div>
      </Card>

      <Card>
        <div className="flex items-center gap-2 font-head font-semibold text-slate-900 mb-4"><KeyRound className="h-4 w-4" /> {t("changePassword")}</div>
        <div className="space-y-4">
          <div>
            <Label>{t("currentPassword")}</Label>
            <Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="mt-1.5" data-testid="pw-current" />
          </div>
          <div>
            <Label>{t("newPassword")}</Label>
            <Input type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="mt-1.5" data-testid="pw-new" />
          </div>
          <Button onClick={changePw} variant="outline" data-testid="pw-save">{t("changePassword")}</Button>
        </div>
      </Card>
    </div>
  );
}
